import React from "react";
import { Box } from "@mui/material";
import { dt } from "../../../../shared/themes/redesignTokens";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { Offer } from "../../models/models";

interface OfferApproachCardProps {
  offer: Partial<Offer>;
}

const OfferApproachCard: React.FC<OfferApproachCardProps> = ({ offer }) => {
  const { translate } = useTranslation(["serviceOffers"]);

  if (!offer.serviceApproach && !offer.specialEquipmentRequired) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: dt.cardBg,
        border: `1px solid ${dt.cardBorder}`,
        borderRadius: dt.radius,
        padding: "20px",
      }}
    >
      <Box
        sx={{
          fontSize: "11px",
          fontWeight: 700,
          textTransform: "uppercase",
          letterSpacing: "1px",
          color: dt.textMuted,
          fontFamily: dt.font,
          mb: "12px",
        }}
      >
        {translate("serviceApproach")}
      </Box>

      {offer.serviceApproach && (
        <Box sx={{ mb: offer.specialEquipmentRequired ? 2 : 0 }}>
          <Box sx={{ fontSize: "12px", fontWeight: 600, fontFamily: dt.font, color: dt.textSecondary, mb: "4px" }}>
            {translate("serviceApproachDescription")}
          </Box>
          <Box sx={{ fontSize: "14px", fontFamily: dt.font, color: dt.textPrimary, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
            {offer.serviceApproach}
          </Box>
        </Box>
      )}

      {offer.specialEquipmentRequired && (
        <Box>
          <Box sx={{ fontSize: "12px", fontWeight: 600, fontFamily: dt.font, color: dt.textSecondary, mb: "4px" }}>
            {translate("specialEquipmentRequired")}
          </Box>
          <Box sx={{ fontSize: "14px", fontFamily: dt.font, color: dt.textPrimary, whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
            {offer.specialEquipmentRequired}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default OfferApproachCard;
